import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/service'

/**
 * @description: 获取可指派导游
 * @param {*} data
 * @return {*}
 */
export function postGuidesWith(data) {
  return axios.post(`${ApiUrl}/guides_with_order/`, data)
}

/**
 * @description: 指派导游
 * @param {*} data
 * @return {*}
 */
export function postGuidesAssign(data) {
  return axios.post(`${ApiUrl}/guide/assign/`, data)
}
